"use client";

import { Button } from "@relume_io/relume-ui";
import React from "react";
import { Link } from "react-router-dom";
import { RxChevronRight } from "react-icons/rx";
import aiAssistant1 from "../../assets/images/home/ai_assistant_01.png";
import aiAssistant3 from "../../assets/images/home/ai_assistant_03.png";
import aiAssistant5 from "../../assets/images/home/ai_assistant_05.png";
import { ImageWithZoom } from "../../components/shared/ImageModal";

export function Layout240() {
  return (
    <section id="relume" className="px-[5%] py-16 md:py-24 lg:py-28">
      <div className="container">
        <div className="rb-12 mx-auto mb-12 w-full max-w-lg text-center md:mb-18 lg:mb-20">
          <h2 className="text-4xl font-bold leading-[1.2] md:text-5xl lg:text-6xl">
            Discover the seamless transformation of stories across multiple
            media platforms.
          </h2>
        </div>
        <div className="grid grid-cols-1 items-start justify-center gap-y-12 md:grid-cols-3 md:gap-x-8 md:gap-y-16 lg:gap-x-12">
          <div className="flex w-full flex-col items-center text-center">
            <div className="rb-6 mb-6 md:mb-8">
              <ImageWithZoom
                src={aiAssistant1}
                alt="AI Assistant Evolution"
                className="w-full"
              />
            </div>
            <h3 className="mb-3 text-xl font-bold md:mb-4 md:text-2xl">
              Experience the evolution of narratives from concept to immersive
              worlds.
            </h3>
            <p>
              Omnigeist expertly adapts your stories, ensuring consistency and
              creativity at every step.
            </p>
            <div className="mt-6 flex flex-wrap items-center gap-4 md:mt-8">
              <Link to="/product" className="no-underline">
                <Button iconRight={<RxChevronRight />} variant="link" size="link">
                  Learn More
                </Button>
              </Link>
            </div>
          </div>
          <div className="flex w-full flex-col items-center text-center">
            <div className="rb-6 mb-6 md:mb-8">
              <ImageWithZoom
                src={aiAssistant3}
                alt="AI Assistant Transformation"
                className="w-full"
              />
            </div>
            <h3 className="mb-3 text-xl font-bold md:mb-4 md:text-2xl">
              Transform your story into a graphic novel, video series, or game.
            </h3>
            <p>
              Our innovative approach guarantees that your narrative remains
              cohesive across all formats.
            </p>
            <div className="mt-6 flex flex-wrap items-center gap-4 md:mt-8">
              <Link to="/contact?type=product" className="no-underline">
                <Button iconRight={<RxChevronRight />} variant="link" size="link">
                  Sign Up
                </Button>
              </Link>
            </div>
          </div>
          <div className="flex w-full flex-col items-center text-center">
            <div className="rb-6 mb-6 md:mb-8">
              <ImageWithZoom
                src={aiAssistant5}
                alt="AI Assistant Community"
                className="w-full"
              />
            </div>
            <h3 className="mb-3 text-xl font-bold md:mb-4 md:text-2xl">
              Join a community where storytelling knows no boundaries or
              limitations.
            </h3>
            <p>
              With Omnigeist, your imagination is the only limit to what can be
              created.
            </p>
            <div className="mt-6 flex flex-wrap items-center gap-4 md:mt-8">
              <Link to="/contact?type=product" className="no-underline">
                <Button iconRight={<RxChevronRight />} variant="link" size="link">
                  Get Started
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
